import type { CohortRow } from './types'
import { formatBusinessDate } from '../common/access-window'

/**
 * Explain why a cohort cannot supply a complete, lockable enrollment.
 *
 * Keep this shared between every enrollment surface. A missing goal used to
 * be a quiet “not set” inside the new-student summary while repeat enrollment
 * rendered a blocking warning for the same cohort.
 */
export function cohortEnrollmentReadinessProblems(
  cohort: CohortRow,
  businessToday: string,
): string[] {
  const problems: string[] = []
  if (cohort.scheduledStartOn === null) {
    problems.push('Start date is not set.')
  }
  if (cohort.accessEndsOn < businessToday) {
    problems.push(`Access ended on ${formatBusinessDate(cohort.accessEndsOn, '')}.`)
  }
  if (cohort.defaultProgramId.trim() === '') {
    problems.push('Program is not set.')
  }
  if (cohort.defaultTrophyGoal === null || cohort.defaultTrophyGoal <= 0) {
    problems.push('Trophy goal must be set.')
  }
  return problems
}
